import { useEffect, useRef, useState } from "react";

/**
 * Animated numeric counter that starts when the element enters the viewport.
 */
export function CountUp({ end, duration = 1600, decimals = 0, suffix = "", prefix = "" }) {
  const [value, setValue] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // Reset guard when `end` changes so dynamic stats (from /api/stats) re-animate.
    started.current = false;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && !started.current) {
            started.current = true;
            const from = 0;
            const start = performance.now();
            const animate = (now) => {
              const p = Math.min((now - start) / duration, 1);
              const eased = 1 - Math.pow(1 - p, 3);
              setValue(from + (end - from) * eased);
              if (p < 1) requestAnimationFrame(animate);
            };
            requestAnimationFrame(animate);
          }
        });
      },
      { threshold: 0.4 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [end, duration]);

  const formatted =
    decimals === 0
      ? Math.round(value).toLocaleString("en-US")
      : value.toFixed(decimals);

  return (
    <span ref={ref}>
      {prefix}
      {formatted}
      {suffix}
    </span>
  );
}
